import React from 'react'
import { LayoutBand, Subheading, Separator, H5 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import CookiePreferences from '@fs/zion-cookie-preferences'
import Button from '../buttons/PillButton'

interface NoConsentViewProps {
  children?: React.ReactNode
}

export const NoConsentView = ({ children }: NoConsentViewProps): JSX.Element => {
  const { t } = useTranslation()
  return (
    <>
      {children ?? (
        <LayoutBand alignY="middle">
          <H5 centered>
            {t(
              'video.cookie-pref.label',
              'This session uses YouTube, which is currently blocked by your cookie preferences.'
            )}
            <Subheading>
              {t('video.cookie-pref.sublabel', 'To view this session, enable Advertising Cookies in the preferences.')}
            </Subheading>
          </H5>
          <Separator />
          <CookiePreferences includeButton={false}>
            <Button emphasis="high" centered>
              {t('video.cookie-pref.action', 'Cookie Preferences')}
            </Button>
          </CookiePreferences>
        </LayoutBand>
      )}
    </>
  )
}
